import React, {Component} from 'react';
import {Tabs} from '../widgets';
import {connect} from 'react-redux';
import BioHelper from './BioHelper';
import actions from './profile.actions';
import {COUPON_STREAM_WHITELISTED_USERS} from '../betaFeatureWhiteList';

class ProfileTabs extends Component {
	componentWillUnmount() {
		this.props.profileUnloaded && this.props.profileUnloaded();
	}

	render() {
		const {currentSession, profile} = this.props;
		const {uniqueName} = this.props.match.params;

		if (!profile) return null; // Don't show tabs until profile loaded.

		const items = [];

		const isViewingOwn =
			(profile && profile.user && profile.user.uuid) ===
			(currentSession && currentSession.user && currentSession.user.uuid);

		// Account tab should only be visible on YOUR profile (or you're an admin)
		if (
			currentSession &&
			(currentSession.provider.uuid === profile.uuid || currentSession.user.admin)
		) {
			items.push({
				link: '/account/' + uniqueName,
				icon: 'icon-person',
				label: 'Account'
			});
		}

		// Favourites tab should only be visible if you're logged in and the user has made them public (or you're an admin or its YOUR profile)
		if (
			currentSession &&
			(profile.favouritesPublic ||
				currentSession.provider.uuid === profile.uuid ||
				currentSession.user.admin)
		) {
			items.push({
				link: '/collections/' + uniqueName,
				icon: 'icon-favorite',
				label: 'My providers',
				children: isViewingOwn ? (
					<BioHelper
						stepKey="collections"
						center={true}
						subscriptionLevel={profile.subscriptionLevel}
					/>
				) : (
					undefined
				)
			});
		}

		// Metrics tab should only be visible if you're an admin or its YOUR profile and you have adequate subscription level
		if (
			currentSession &&
			(currentSession.provider.uuid === profile.uuid || currentSession.user.admin) &&
			['essentials', 'premium'].indexOf(profile.subscriptionLevel) >= 0
		) {
			items.push({
				link: '/metrics/' + uniqueName,
				icon: 'icon-multiline_chart',
				label: 'Metrics'
			});
		}

		// If neither option is available, tabs should not render at all (return null)
		if (!items.length) {
			return null;
		}

		items.push({
			link: '/@' + uniqueName,
			icon: 'icon-public',
			label: 'Profile'
		});

		// check if profie is for same user who is currently logged in i.e - only show own coupons
		// also check if current logged in provider is allowed to access coupons feature
		if (currentSession && COUPON_STREAM_WHITELISTED_USERS.includes(currentSession.user.uuid)) {
			items.push({
				link: '/profile/coupons/' + uniqueName,
				icon: 'icon-loyalty',
				label: 'Promotions'
			});
		}

		return <Tabs items={items} />;
	}
}

const ConnectedProfileTabs = connect(
	({session, profile}) => ({
		currentSession: session && session.current,
		profile
	}),
	dispatch => ({
		profileUnloaded: () => dispatch(actions.profileUnloaded())
	})
)(ProfileTabs);

export default ConnectedProfileTabs;



// WEBPACK FOOTER //
// ./src/profile/ProfileTabs.js